export default "__VITE_ASSET__D60WQWhb__"